/**
 * @fileoverview View User dialog hook.
 * @description The View dialog's data: reads the user's details (GET /users/{userId}). The dialog
 * stays mounted with an empty userId, in which case nothing is read.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useUserDetail } from '@/features/users/hooks/useUserDetail'

/**
 * @description Loads the user the View dialog shows.
 * @param {string} userId - The user to show, or '' while the dialog is closed.
 * @returns {object} The user, and whether the read is loading or failed.
 */
export function useViewUserDialog(userId: string) {
  const detailQuery = useUserDetail(userId)

  return {
    user: detailQuery.data?.user,
    isLoading: detailQuery.isPending,
    error: detailQuery.isError ? detailQuery.error : null,
  }
}
